import React, { useEffect } from 'react';
import  '../styles/linkedin.css';
import Header from './Header';
import Sidebar from './Sidebar';
import MiddleSection from './MiddleSection';
import { fetchUser, login, logout } from '../features/UserSlice';
import { useDispatch, useSelector } from 'react-redux';
import {MemoizedLogin} from './Login';
import { auth } from '../firebase';
import RightWidgets from './RightWidgets';

function LinkedInHomePage(props) {

    //fetch state user data here
    const user = useSelector(fetchUser);

    // dispatch in store 
    const dispatch = useDispatch();

    useEffect(()=>{
        auth.onAuthStateChanged((userAuth) =>{
            if(userAuth){
                //user is logged in 
                //then dispatch them in store
                dispatch(login({
                    email:userAuth.email,
                    uid: userAuth.uid,
                    displayName: userAuth.displayName,
                    photoURL:userAuth.photoURL
                }))
            }else{
                //user is logged out
                dispatch(logout());
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        <div className="linkedin_home">
             <Header/>

             {
                 !user   ?
                 (<div><MemoizedLogin user={user}/></div>) 
                 : (
                    <div className="linkedin_body">
                    <Sidebar/>
                    <MiddleSection/>
                    <RightWidgets/>
                </div>
                 )
             }


        </div>
    );
}

export default LinkedInHomePage;